<template>
  <div>
    <button
      v-for="page in myArray"
      :key="page"
      class="button"
      :class="{activePage: (curPage==page)}"
      @click="$emit('page-selected',page)"
    >{{ page }}</button>
  </div>
</template>

<script>
export default {
  props: ["myArray", "curPage"]
};
</script>

<style>
.activePage {
  filter: brightness(85%);
}
</style>